import type { NNavigation } from '@app/types';

export const checkForAllPathEnds = (
  currentPathName: string,
  navigationPath: NNavigation.GeneralItemProps['path']
): boolean => {
  const isPathWithEndSlash =
    currentPathName.charAt(currentPathName.length - 1) === '/';
  const mainCondition = currentPathName === navigationPath;

  if (isPathWithEndSlash) {
    return mainCondition || currentPathName === `${navigationPath}/`;
  }

  return (
    mainCondition ||
    currentPathName === navigationPath.slice(0, navigationPath.length - 1)
  );
};
